import { render, staticRenderFns } from "./Textbox.vue?vue&type=template&id=637cd8bf&scoped=true&"
import script from "./Textbox.vue?vue&type=script&lang=js&"
export * from "./Textbox.vue?vue&type=script&lang=js&"
import style0 from "./Textbox.vue?vue&type=style&index=0&id=637cd8bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637cd8bf",
  null
  
)

export default component.exports